/**
 * Import Dependency
 */
import { createAction } from 'redux-actions'
import {
  GET_ACTIVE_TABLES,
  GET_ACTIVE_TABLES_ORDERS,
  UPDATE_SELECTED_TABLE,
} from '../../constants/actionType'
import tableApi from '../../services/api/table'
import * as _ from 'lodash'

/**
 * Declare Variable
 */
const getActiveTablesAction = createAction(GET_ACTIVE_TABLES)
const getActiveTablesOrdersAction = createAction(GET_ACTIVE_TABLES_ORDERS)
const updateSelectedTableAction = createAction(UPDATE_SELECTED_TABLE)

/**
 * Export
 */
export const getActiveTables = () => async (dispatch, getState) => {
  try {
    const { user, merchant } = getState()
    const isWaiter = merchant && user && (user.permissions || []).indexOf(merchant.id + ':waiter') >= 0

    if (isWaiter) {
      const res = await tableApi.getActiveTables()
      // > expect an object of arrays. {[activeTables], [ordersOfActiveTables]}
      if (_.get(res, 'tables')) { dispatch(getActiveTablesAction(res.tables)) }
      // if (_.get(res, 'orders')) { dispatch(getActiveTablesOrdersAction(res.orders)) }
    }
  } catch (error) {
    console.error('getActiveTables error', error)
    return Promise.reject(error)
  }
}

export const updateSelectedTable = (table) => async (dispatch) => {
  dispatch(updateSelectedTableAction(table))
  const res = await tableApi.listActiveOrders(table)
  if (_.get(res, 'orders')) { dispatch(getActiveTablesOrdersAction(res.orders)) }
}



// WEBPACK FOOTER //
// ./src/actions/components/table.js